<template>
    <v-layout>
        <v-flex v-if="showRequestButton" xs12>
            <v-btn class="primary_btn transparent"
                   data-qe-id="open_new_grou_request_btn"
                   @click="openNewGroupRequest()">
                {{groupConstants.REQUEST_NEW_GROUP}}
            </v-btn>
        </v-flex>
        <v-dialog
            scrollable
            content-class="small"
            v-model="opendialog"
            persistent>
            <v-card class="request-new-group custom-dailog">
                <v-card-title>
                    {{groupConstants.REQUEST_GROUP}}
                    <i class="fas fa-times" @click="cancelDialog()" data-qe-id="close_dialog_btn"></i>
                </v-card-title>
                <v-card-text class="inner-scrollbar group-non-member-message">
                    <v-flex>
                        <span v-html="communityCommonConstant.group.EXPLOREGROUPS"></span>
                        Click <strong><a class="group-non-member-message__directoryLink"
                                         data-qe-id="show_group_directory_btn"
                                         @click="showGroupDirectory">here</a></strong>
                        {{communityCommonConstant.group.GROUP_NONMEMBER_MESSAGE_POST}}
                    </v-flex>
                    <div class="group-non-member-message__request mt-4">
                        <p>{{communityCommonConstant.group.REQUEST_GROUP_INFO}}</p>
                    </div>
                    <group-request v-if="opendialog" :isNewRequestGroup=true
                                   data-qe-id="cancel_dialog_btn"
                                   @close="cancelDialog" class="group-non-member-message__form"></group-request>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import { groupConstants } from '../GroupPage/groupConstant';
    import GroupConfiguration from './GroupConfiguration';
    import GroupRequest from './GroupRequest';
    import { communityCommonConstant } from "../ChapterPage/communityCommon.constant";

    export default {
        name: "GroupRequestNewGroup",
        props: {
            showRequestButton: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                groupConstants,
                opendialog: false,
                communityCommonConstant,
            };
        },
        components: {
            GroupConfiguration,
            GroupRequest,
        },
        methods: {
            openNewGroupRequest() {
                this.opendialog = true;
            },
            cancelDialog() {
                this.opendialog = false;
            },
            showGroupDirectory() {
                this.$router.push({
                    path: '/communityDirectoryPage',
                    query: {
                        filters: '',
                        navigatedFromId: '',
                        communitySearchText: '',
                        communityFilters: JSON.stringify({
                            "CommunityType": [{
                                "label": "Group",
                                "filterKey": "CommunityType",
                                "filterValue": "Group",
                                "isTypeAhead": false,
                                "subFilters": [],
                                "ribbonGroupName": "Community Type",
                            }],
                            "CommunityFocus": [],
                            "EligibilityRequirements": [],
                        }),
                    },
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";

    .request-new-group {
        position: relative;

        &__header {
            text-align: center;
            height: 120px;
            background-color: $ypo-dark-background-gray;
            font-weight: lighter;
            color: $white;
            padding-top: 8px;
        }

        h2 {
            color: $white;
            margin: 50px 0 0 20px;
            font-size: 31px;
            font-weight: lighter;
        }

        &__cont {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            text-align: center;
        }

    }

    .group-non-member-message {
        .button-group {
            margin: 0 !important;
        }
    }

    .custom-dailog {
        .v-card__title {
            background-color: $ypo-tile-border;
            color: $ypo-blue;
            font-family: Raleway;
            font-size: 24px;
            font-weight: 500;
            line-height: 30px;
            position: relative;

            i {
                color: $ypo-cta;
                position: absolute;
                right: 20px;
                cursor: pointer;
            }
        }

        .v-card__text {
            margin-right: 5px;
            width: auto;
        }

        .v-card__actions {
            border-top: 1px solid $ypo-medium-gray;
        }
    }
</style>
